<template>
  <parent-tabs :tabs="filterTabs()" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PpmCalcParent',
  methods: {
    filterTabs () {
      return this.pageTabs.reduce((accu, i) => {
        if (i.can) accu.push(i)
        return accu
      }, [])
    }
  },
  computed: {
    ...mapGetters({
      can: 'can'
    }),
    pageTabs () {
      return [
        { id: 1, title: 'List', route: '/ppm-calculation-list', can: this.can('api.view_purchase') },
        { id: 2, title: 'Create', route: '/create-ppm-calculation', can: this.can('api.add_ppmcalculation') }
      ]
    }
  }
}
</script>
